const actions = {
  CREATE_INBOX_MESSAGE: 'CREATE_INBOX_MESSAGE',
  CREATE_INBOX_MESSAGE_ENDED: 'CREATE_INBOX_MESSAGE_ENDED',
  SEARCH_INBOX_MESSAGES: 'SEARCH_INBOX_MESSAGES',
  SEARCH_INBOX_MESSAGES_ENDED: 'SEARCH_INBOX_MESSAGES_ENDED',
  FIND_INBOX_MESSAGE: 'FIND_INBOX_MESSAGE',
  FIND_INBOX_MESSAGE_ENDED: 'FIND_INBOX_MESSAGE_ENDED',
  COPY_INBOX_MESSAGE: 'COPY_INBOX_MESSAGE',
  COPY_INBOX_MESSAGE_ENDED: 'COPY_INBOX_MESSAGE_ENDED',
  UPDATE_INBOX_MESSAGE: 'UPDATE_INBOX_MESSAGE',
  UPDATE_INBOX_MESSAGE_ENDED: 'UPDATE_INBOX_MESSAGE_ENDED',
  DELETE_INBOX_MESSAGES: 'DELETE_INBOX_MESSAGES',
  DELETE_INBOX_MESSAGES_ENDED: 'DELETE_INBOX_MESSAGES_ENDED',
  ARCHIVE_ALL_CMS: 'ARCHIVE_ALL_CMS',
  ARCHIVE_ALL_CMS_ENDED: 'ARCHIVE_ALL_CMS_ENDED',

  CREATE_INBOX_LINE_MESSAGE: 'CREATE_INBOX_LINE_MESSAGE',
  CREATE_INBOX_LINE_MESSAGE_ENDED: 'CREATE_INBOX_LINE_MESSAGE_ENDED',
  SEARCH_INBOX_LINE_MESSAGES: 'SEARCH_INBOX_LINE_MESSAGES',
  SEARCH_INBOX_LINE_MESSAGES_ENDED: 'SEARCH_INBOX_LINE_MESSAGES_ENDED',
  FIND_INBOX_LINE_MESSAGE: 'FIND_INBOX_LINE_MESSAGE',
  FIND_INBOX_LINE_MESSAGE_ENDED: 'FIND_INBOX_LINE_MESSAGE_ENDED',
  UPDATE_INBOX_LINE_MESSAGE: 'UPDATE_INBOX_LINE_MESSAGE',
  UPDATE_INBOX_LINE_MESSAGE_ENDED: 'UPDATE_INBOX_LINE_MESSAGE_ENDED',
  DELETE_INBOX_LINE_MESSAGES: 'DELETE_INBOX_LINE_MESSAGES',
  DELETE_INBOX_LINE_MESSAGES_ENDED: 'DELETE_INBOX_LINE_MESSAGES_ENDED',
  ARCHIVE_ALL_INBOX_LINE_MESSAGES: 'ARCHIVE_ALL_INBOX_LINE_MESSAGES',
  ARCHIVE_ALL_INBOX_LINE_MESSAGES_ENDED: 'ARCHIVE_ALL_INBOX_LINE_MESSAGES_ENDED',
  GET_LINE_BATCH_PUSH_TASK_STATUS: 'GET_LINE_BATCH_PUSH_TASK_STATUS',
  GET_LINE_BATCH_PUSH_TASK_STATUS_END: 'GET_LINE_BATCH_PUSH_TASK_STATUS_END',
};

export default actions;
